const SUPPORTING_TYPES = new Set(["research_brief", "image_prompt", "execution_report"]);

export function getRunImagePrompt(assets = []) {
  return extractImagePromptSections(assets.find((asset) => asset?.asset_type === "image_prompt" && asset.body)?.body || "").imagePrompt;
}

export function getRunCoverPrompt(assets = []) {
  const sections = extractImagePromptSections(assets.find((asset) => asset?.asset_type === "image_prompt" && asset.body)?.body || "");
  return sections.coverPrompt || sections.imagePrompt;
}

export function extractImagePromptSections(body = "") {
  const text = String(body || "").trim();
  if (!text) return { imagePrompt: "", coverPrompt: "" };
  const imageMatch = text.match(/(?:^|\n)Image Prompt\s*\n([\s\S]*?)(?=\n(?:Designed Text|Visual Strategy|Free\/Fallback Cover Prompt)\s*\n|$)/i);
  const fallbackMatch = text.match(/(?:^|\n)Free\/Fallback Cover Prompt\s*\n([\s\S]*?)$/i);
  return {
    imagePrompt: (imageMatch ? imageMatch[1] : text).trim(),
    coverPrompt: (fallbackMatch ? fallbackMatch[1] : "").trim(),
  };
}

export function attachRunImagePrompt(assets = []) {
  const sections = extractImagePromptSections(assets.find((asset) => asset?.asset_type === "image_prompt" && asset.body)?.body || "");
  const imagePrompt = sections.imagePrompt;
  const coverPrompt = sections.coverPrompt || sections.imagePrompt;
  if (!imagePrompt && !coverPrompt) return assets;
  return assets.map((asset) => (
    SUPPORTING_TYPES.has(asset?.asset_type) ? asset : { ...asset, image_prompt: imagePrompt, cover_prompt: coverPrompt }
  ));
}

export function attachImagePromptsForRuns(assets = [], runs = []) {
  if (!Array.isArray(assets) || !assets.length || !Array.isArray(runs) || !runs.length) return assets;
  const byId = new Map(assets.map((asset) => [asset.id, asset]));
  const promptsByAssetId = new Map();

  runs.forEach((run) => {
    const runAssetIds = Array.isArray(run?.asset_ids) ? run.asset_ids : [];
    const runAssets = runAssetIds.map((id) => byId.get(id)).filter(Boolean);
    const imagePromptAsset = runAssets.find((asset) => asset?.asset_type === "image_prompt" && asset.body);
    if (!imagePromptAsset) return;
    const sections = extractImagePromptSections(imagePromptAsset.body);
    const imagePrompt = sections.imagePrompt;
    const coverPrompt = sections.coverPrompt || sections.imagePrompt;
    if (!imagePrompt && !coverPrompt) return;

    runAssets.forEach((asset) => {
      if (!asset?.id || SUPPORTING_TYPES.has(asset.asset_type)) return;
      promptsByAssetId.set(asset.id, { imagePrompt, coverPrompt });
    });
  });

  if (promptsByAssetId.size === 0) return assets;
  return assets.map((asset) => {
    const prompts = promptsByAssetId.get(asset?.id);
    if (!prompts) return asset;
    return {
      ...asset,
      image_prompt: asset.image_prompt || prompts.imagePrompt,
      cover_prompt: asset.cover_prompt || prompts.coverPrompt,
    };
  });
}

export function getAssetImagePrompt(asset) {
  return asset?.image_prompt
    || `A polished, brand-safe social media cover image for "${asset?.title || "this post"}". No text, logos, or watermarks.`;
}

export function getAssetCoverPrompt(asset) {
  return asset?.cover_prompt || getAssetImagePrompt(asset);
}
